import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Upload, Form, Button, Input, Typography, DatePicker } from 'antd'
import moment from 'moment'

const { Text, Title } = Typography

class InputDateStartEnd extends Component {
	state = {
		// file: undefined
        disabledDateStart:null
	}


    onChangeValueDateStart = async (e) =>{
       this.setState({
            disabledDateStart: moment(e).endOf('day')
       })
    }

    disabledDate = (current) =>{
		const { disabledDateStart } = this.state
        return current && current < disabledDateStart;
    }

    componentDidMount(){
		const { valuesStartDate } = this.props

        console.log(moment(valuesStartDate).endOf('day'))

        if(valuesStartDate){
            this.setState({
                disabledDateStart:moment(valuesStartDate).endOf('day')
            })
        }
    }

	render() {
		const { 
            requiredDateStart, 
            nameDateStart, 
            nameDateEnd, 
            labelDateStart, 
            labelDateEnd, 
            valuesStartDate, 
            valuesEndDate,
            inlineBlock = null
        } = this.props
		const { disabledDateStart } = this.state
		const { getFieldDecorator } = this.props.form;

		return (
			<>
                {/* <div style={{ display:"inline-block" }} className={ inlineBlock ? "w-50 pr-3" : "w-100"}>
                    <Form.Item
                        name={ nameDateStart }
                        label={ labelDateStart }
                        rules={ requiredDateStart ? [{ required: true, message: 'กรุณากรอก '+labelDateStart }] : ''}
                        initialValue={ valuesStartDate ? moment(valuesStartDate) : '' }
                    >
                        <DatePicker className="w-100" defaultValue={ valuesStartDate ? moment(valuesStartDate) : '' } placeholder="เลือกวันที่" onChange={(e) => this.onChangeValueDateStart(e)}/>
                    </Form.Item>
                </div>

                <div style={{ display:"inline-block" }} className={ inlineBlock ? "w-50" : "w-100"}>
                    <Form.Item
                        name={ nameDateEnd }
                        label={ labelDateEnd }
                        rules={ '' }
                        initialValue={ valuesEndDate ? moment(valuesEndDate) : '' }
                    >
                        <DatePicker 
                            disabledDate={this.disabledDate} 
                            disabled={ disabledDateStart ? false : true }
                            className="w-100" 
                            defaultValue={ valuesEndDate ? moment(valuesEndDate) : '' } 
                            placeholder="เลือกวันที่"
                        />
                    </Form.Item>
                </div> */}
                <div style={{ display:"inline-block" }} className={ "w-50 pr-3"}>
				    <Form.Item label={labelDateStart} className="mb-0">
                        { getFieldDecorator(nameDateStart, {
                            initialValue: valuesStartDate ? moment(valuesStartDate) : '',
                            rules:  [{ 
                                required:false,
                                message: 'กรุณากรอกหรือเลือก '+labelDateStart,
                            }],
                        })(
                            <DatePicker className="w-100"  placeholder="เลือกวันที่" onChange={(e) => this.onChangeValueDateStart(e)}/>
                        )}
				    </Form.Item>
                </div>

                <div style={{ display:"inline-block" }} className="w-50">
                    <Form.Item label={labelDateEnd} className="mb-0">
                        { getFieldDecorator(nameDateEnd, {
                            initialValue: valuesEndDate ? moment(valuesEndDate) : '',
                            rules:  [{ 
                                required:false,
                                message: 'กรุณากรอกหรือเลือก '+labelDateEnd,
                            }],
                        })(
                            <DatePicker 
                                disabledDate={this.disabledDate} 
                                disabled={ disabledDateStart ? false : true }
                                className="w-100" 
                                placeholder="เลือกวันที่"
                            />
                        )}
				    </Form.Item>
                </div>
			</>
		)
	}
}

InputDateStartEnd.defaultProps = {
	autoFocus: false
}

InputDateStartEnd.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedInputDateStartEnd = Form.create()(InputDateStartEnd)

export default withApollo(WrappedInputDateStartEnd)